// Environment configuration for server connections
const parseBooleanEnv = (value, defaultValue = true) => {
  if (value === undefined) {
    return defaultValue;
  }

  return value.toLowerCase() === "true";
};

const getServerConfig = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const socketsEnabled = parseBooleanEnv(
    process.env.REACT_APP_ENABLE_SOCKETS,
    true,
  );

  if (isProduction) {
    // In production, use relative URLs (same domain)
    return {
      apiBaseUrl: "",
      socketUrl: window.location.origin,
      socketsEnabled,
    };
  } else {
    // In development, use localhost:5602
    return {
      apiBaseUrl: "http://localhost:5602",
      socketUrl: "http://localhost:5602",
      socketsEnabled,
    };
  }
};

export const { apiBaseUrl, socketUrl, socketsEnabled } = getServerConfig();
